import api from "../components/api";

const BACKEND_URL = "https://cbackend.xraidigital.com/api/services/";

export function isBrowserOnline() {
  return navigator.onLine;
}

export function isOnline() {
  return navigator.onLine;
}


export async function isBackendReachable() {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 4000); // 4 sec max

  try {
    const response = await fetch(BACKEND_URL, {
      method: "GET",
      cache: "no-store",
      signal: controller.signal
    });

    clearTimeout(timeout);
    return response.ok;
  } catch (err) {
    return false;
  }
}

export async function isAppOnline() {
  return await isBackendReachable();
}

export async function isBackendReady() {
  try {
    await api.options("/technician/audiometry/", {
      timeout: 3000
    });
    return true;
  } catch (err) {
    // DNS error, timeout, server down → NOT ready
    return false;
  }
}